import {RepositoryFactory} from '@/api/factory/repositoryFactory'
const anonymousActiveCode = RepositoryFactory.get('anonymousActiveCode')

const state = {
  activeCodes: [],
  count: 0
}

const actions = {
  async fetchActiveCodes({commit}, params = {}) {
    const res = await anonymousActiveCode.fetch({
      ...params,
    })
    commit('setActiveCodes', res.data || [])
    return res.data
  },
  async countActiveCodes({commit}, params = {}) {
    const res = await anonymousActiveCode.count({
      ...params,
    })
    commit('setCount', res.data || [])
    return res.data
  },
  async updateActiveCode({commit}, {id, data}) {

    const res = await anonymousActiveCode.update(id, data)
    commit('setActiveCode', res.data)
    return res.data
  },
}

const mutations = {
  setActiveCodes(state, activeCodes) {
    return (state.activeCodes = activeCodes)
  },
  setCount(state, count) {
    return (state.count = count)
  },
}

const getters = {
  getActiveCodes: (state) => {
    return state.activeCodes
  },
  getCount: (state) => {
    return state.count
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
